export enum SimNao {
  SIM = 'SIM',
  NAO = 'NAO',
  SIM_STRING = 'Sim',
  NAO_STRING = 'Não'
}
